function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 1,
  width: 18,
  height: 19,
  rx: 1,
  fill: "#A8FFF8"
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 16,
  width: 18,
  height: 10,
  rx: 1,
  fill: "#CBFF88"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 4.5a.5.5 0 01.5-.5h18a.5.5 0 01.5.5v20a.5.5 0 01-.5.5h-18a.5.5 0 01-.5-.5v-20zM8 5v19h17V5H8z",
  fill: "#14454C"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 7a.5.5 0 01.5.5V28h18.5a.5.5 0 010 1h-19a.5.5 0 01-.5-.5v-21a.5.5 0 01.5-.5z",
  fill: "#14454C"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#14454C",
  strokeLinecap: "round",
  d: "M10.5 9.5h8M10.5 14.5h12M10.5 19.5h12"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#14454C",
  fillOpacity: 0.15,
  d: "M8 13h17v11H8z"
});
function SvgSummary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}
export default __webpack_public_path__ + "fonts/summary-b118af12bafe60fc69711cb6a6b9789a.svg";
export { SvgSummary as ReactComponent };